export const toDate = (value) => value ? new Date(value).toLocaleString() : '';

export const toDateFromPtBr = (value) => {
  let date = '';
  if (value && value.length > 8) {
    const array = value.split('/');
    if (array.length >= 2) {
      date = `${array[2]}/${array[1]}/${array[0]}`;
    }
  }
  return date;
};

export const toMoney = (value) =>
  `${value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const toPhone = (value) => {
  if (value != null) {
    const phone = value.replace(/[^\d]/g, '');
    if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      return phone.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4');
    }
  } else {
    return '';
  }
};

export const toFullDate = (value) => {
  const date = new Date(value);
  return `0${date.getDate()}`.slice(-2) + '/' + `0${date.getMonth() + 1}`.slice(-2) +
    '/' + `${date.getFullYear()}`.slice(-2);
};

export const toMonthYearDate = (value) => {
  const date = new Date(value);
  return `0${date.getMonth() + 1}`.slice(-2) + '/' + `${date.getFullYear()}`.slice(-2);
};
export const toISO = (value) => {
  let date = '';
  if (value && value.length > 8) {
    const array = value.split('/');
    if (array.length >= 2) {
      date = `${array[2]}-${array[1]}-${array[0]}`;
    }
  }
  return date;
};

export const roundTo = function(num, places) {
  const factor = 10 ** places;
  return Math.round(num * factor) / factor;
};
